import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import Transition from 'react-transition-group/Transition'
import { colors, LockScroll } from '@offerzen/pinata'

import CloseIcon from '@offerzen/zenicon/CloseIcon'
import AccessibleIcon from '../../../components/AccessibleIcon'

import { styles, size, getTransitionClass } from './styles'

class ZenModal extends PureComponent {
  render() {
    return (
      <LockScroll locked={this.props.isActive}>
        <Transition in={this.props.isActive} mountOnEnter unmountOnExit timeout={300}>
          {state => (
            <div
              role="dialog"
              aria-label={`modal-${this.props.name || 'dialog'}`}
              className={cx(styles.overlay, getTransitionClass.overlay[state], this.props.overlayClass, this.props.activeClass)}>
              <div
                className={styles.outsideClick}
                onClick={this.props.overlayDismiss && this.props.toggleActive}
                onDoubleClick={this.props.overlayDismiss && this.props.toggleActive}
              />

              <div className={cx(styles.container, size(this.props.size), getTransitionClass.modal[state], this.props.modalClass)}>
                <span className={cx(styles.closeButton, this.props.closeButtonClass)} onClick={this.props.toggleActive}>
                  <AccessibleIcon icon={CloseIcon} size="20px" color={colors.geyser} />
                </span>
                {this.props.children}
              </div>
            </div>
          )}
        </Transition>
      </LockScroll>
    )
  }
}

ZenModal.defaultProps = {
  size: 'default',
  overlayDismiss: true,
}

ZenModal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleActive: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['', 'default', 'extraSmall', 'small', 'large', 'extraLarge']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  activeClass: PropTypes.string,
  overlayDismiss: PropTypes.bool,
  closeButtonClass: PropTypes.string,
  overlayClass: PropTypes.string,
  modalClass: PropTypes.string,
}

export default ZenModal
